import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

import { Storage } from '@ionic/storage';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

import { CartaofidelidadePage } from '../cartaofidelidade/cartaofidelidade';

@Component({
  selector: 'page-notificacoes',
  templateUrl: 'notificacoes.html',
})
export class NotificacoesPage {

	notificacoes;
    id_empresa = 0;

	constructor(public navCtrl: NavController, public navParams: NavParams, private _apiService: ApiProvider, private loadingCtrl: LoadingController, private storage: Storage, private _auth: AuthProvider)
	{
		let loading = this.loadingCtrl.create({
            content: 'Carregando...'
        });
        loading.present();

        this.storage.set('badge', 0);

        this.storage.get('id_empresa_escolhida').then((val1) => {
            this.id_empresa = val1;
            storage.get('id_cliente').then((val) => {
                this._apiService.getPush({id_cliente: val, id_empresa_escolhida:val1}).subscribe(arg => {
                	// console.log('1',arg);
                	this.notificacoes = arg;
                	loading.dismiss();
                });
            });
            
        });

	}

    // Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter()
    {
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
    }

    abrirEmpresa(id)
    {
        this.storage.set('id_empresa_escolhida', id);
        this.navCtrl.push(CartaofidelidadePage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/notificacoes/notificacoes.ts